import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, LazyImage, MainHeading, SpanStyled, TextStyled } from '../../../ui/Elements'
import { ArrowBtnBrown, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr } from '../../../ui/AllImages'
// import { ContactButton } from '../../ui/CustomElements'

import { useTranslation } from 'react-i18next'
import { clientsItems } from '../../projectData/Data'

const Clients = () => {
    const { t } = useTranslation()
    
    return (
        <>
            <ClientWapper className='container-fluid secClient common-space' id='clients'>
                <Container>
                    <Row className='client-row'>
                        <Col md={12} className='client-col'>
                            <Box className='clientContentDesc'>
                                <MainHeading className='main-heading main-heading-sub' size="32px" color="var(--secondaryColor)">
                                    {t('OurClients')}
                                </MainHeading>
                                <MainHeading className='main-heading mb-4'>
                                    {t('WhoWeWorkWith')}
                                </MainHeading>
                            </Box>
                        </Col>
                        <Col md={12} className='clientsBoxWrapper'>
                            <Box className='clientGrid'>
                                {clientsItems.map((item, index) => (
                                    <Box className='clientGridImg' key={index}>
                                        {item.img}
                                    </Box>
                                ))}
                            </Box>
                        </Col>
                        
                    </Row>
                </Container>
                <Box className='stripe stripe1'></Box>
            </ClientWapper>
            
        </>
    )
}
const ClientWapper = styled.section`
    .clientGrid {
        display: grid;
        grid-template-columns: repeat(20, 1fr);
        gap: 20px;
    }

    .clientGrid > :nth-child(-n+5) {
        grid-column: span 4; /* first 5 items -> each 4/20 = 1/5 */
    }

    .clientGrid > :nth-child(n+6) {
        grid-column: span 5; /* items 6+ -> each 5/20 = 1/4 */
    }

    /* item */
    .clientGridImg {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        width: 100%;
        border-radius: 16px;
        background-color: var(--bg2);
        padding: 15px;
    }
    @media (max-width: 767px) {
        .clientGrid {
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
        }
        .clientGrid > :nth-child(-n+5) {
            grid-column: unset; 
        }

        .clientGrid > :nth-child(n+6) {
            grid-column: unset; 
        }
    }
    @media (max-width: 575px) {
        .clientGrid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
        }
        
    }
    @media (max-width: 450px) {
        .clientGrid {
            grid-template-columns: repeat(1, 1fr);
            gap: 15px;
        }
        
    }
    /* image rules */
    /* .clientGridImg img.client-img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    } */
    
`
export default Clients
